import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'removestar',
    standalone: false
})
export class RemoveStarPipe implements PipeTransform {
	transform(value) {
		if (!value) {
			return '';
		}
		return value.replace(/[&/\\#,+()$~%.'":*?<>{}]/g, '');
	}
}